export default __webpack_public_path__ + "0ca6e2cb58a8b4ed4b69d99ad3fdb65e.png";